export default __webpack_public_path__ + "bc6630a733e4a417137dcad0fa5462b2.png";